import { LocalStorage } from 'quasar'
import { type LocationQuery, useRoute, useRouter } from 'vue-router'

export const useUrchinTracking = () => {
  const route = useRoute()
  const router = useRouter()

  // Save Urchin
  const saveUrchin = async () => {
    const queries = { ...route.query }
    // Only keep the queries that start with 'utm_'
    const utmParams = Object.keys(queries)
      .filter((key) => key.startsWith('utm_'))
      .reduce((obj: LocationQuery, key) => {
        obj[key] = queries[key]
        return obj
      }, {})

    // Save the query parameters in the session storage if it's not empty
    if (Object.keys(utmParams).length > 0) {
      LocalStorage.set('urchin', utmParams)
    }

    // Filter out the utm_ queries from the queries
    Object.keys(utmParams).forEach((key) => delete queries[key])
    // Clean the query parameters

    await router.replace({ query: queries })
  }

  return { saveUrchin }
}
